interface hoverOption {
  /**
   * @description millisecond
   */
  hideDelay?: number
  /**
   * @description millisecond
   */
  showDelay?: number
}

const useMouseHover = (option?: hoverOption) => {
  const show = ref<boolean>(false)
  const hideTimeout = ref<NodeJS.Timeout>()
  const showTimeout = ref<NodeJS.Timeout>()

  const handleMouseOver = () => {
    cancelHide()
    startShow()
  }
  const handleMouseOut = () => {
    cancelShow()
    startHide()
  }

  const startShow = () => {
    const id = setTimeout(() => {
      show.value = true
    }, option?.showDelay)
    showTimeout.value = id
  }

  const startHide = () => {
    const id = setTimeout(() => {
      show.value = false
    }, option?.hideDelay)
    hideTimeout.value = id
  }

  const cancelShow = () => {
    clearTimeout(showTimeout.value)
  }

  const cancelHide = () => {
    clearTimeout(hideTimeout.value)
  }

  return {
    show,
    mouseOver: handleMouseOver,
    mouseOut: handleMouseOut,
  }
}

export default useMouseHover
